import React from 'react';
import { Link } from 'react-router-dom';

const TopBar = () => {
  return (
    <div className="w-full bg-[#141618] text-white">
      <div className="max-w-[1280px] mx-auto flex items-center justify-between px-6 py-3">
        <p className="tracking-[0.3em] text-[11px] md:text-xs text-white/85 font-medium">
          CONCIERGE CARE. CLINICAL EXCELLENCE. DELIVERED TO YOU.
        </p>
        <Link
          to="/contact"
          className="hidden md:inline-block bg-[#c9a961] hover:bg-[#b89751] transition-colors duration-300 text-[#141618] tracking-[0.2em] text-[11px] font-semibold px-6 py-2.5"
        >
          BOOK APPOINTMENT
        </Link>
      </div>
    </div>
  );
};

export default TopBar;
